<template>
  <div class="panel panel-default panel-dashboard">
    <div class="panel-body text-center">
      <div class="row">
        <div class="col-xs-8" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 42px; margin-bottom: 0">
            {{ project.attributes.revenue | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Revenue
          </p>
        </div>

        <div class="col-xs-8" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 42px; margin-bottom: 0">
            {{ project.attributes.open_opportunity_value | price }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Opportunity Value
          </p>
        </div>

        <div class="col-xs-4" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 42px; margin-bottom: 0">
            {{ project.attributes.open_project_lead_count }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Open Leads
          </p>
        </div>

        <div class="col-xs-4">
          <p style="font-size: 42px; margin-bottom: 0">
            {{ project.attributes.ad_count }}
          </p>

          <p class="tw-text-gray-400 tw-mb-0" style="font-size: 12px;">
            Advertisers
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    project:{
      required: true,
      type:Object
    }
  }
}
</script>